import * as z from "zod";

/** The units a deviation product can be priced in: per kg (5) or per tonne (6). */
export const DEVIATION_PRODUCT_UNIT_IDS = ["5", "6"];

const validationSchema = z.object({
  companyId: z.number(),
  name: z.string().min(1, { message: "validation:deviationNameRequired" }),
  price: z.number({ message: "validation:priceRequired" }).min(0, { message: "validation:priceNegative" }),
  priceUnit: z.string().refine((unit) => DEVIATION_PRODUCT_UNIT_IDS.includes(unit), {
    message: "validation:unitRequired",
  }),
  currency: z.string().min(1, { message: "validation:currencyRequired" }),
  description: z.string().max(200, { message: "validation:descriptionMaxLength" }),
});

export const DeviationProductValidationSchema = validationSchema;
export type DeviationProductFormInput = z.infer<typeof DeviationProductValidationSchema>;
